import { Box, Avatar, Text, Badge, Image, Select, Flex, useDisclosure, Tooltip } from "@chakra-ui/react";
import CopyIcon from "../../../../assets/images/CopyIcon.svg";
import BranchIcon from "../../../../assets/images/BranchIcon.svg";
import CompanyIcon from "../../../../assets/images/companyIcon.svg";
import InboxIcon from "../../../../assets/images/InboxIcon.svg";
import CallIcon from "../../../../assets/images/CallIcon.svg";
import MyDiv from "./myDepartmentCard.style";
import { useState , useEffect} from "react";
import { ChevronDownIcon } from "@chakra-ui/icons";
import AlertCard from "../../../../components/AlertCard";
import { CustomToast } from "../../../../components";
import { useFetch } from '../../../../hooks/useFetch';
import { EmployeeCardProps } from "./modal";
import DummyPerson from '../../../../assets/images/DummyPerson.svg'
const MyDepartmentCard = ({ employee, statusDD }: EmployeeCardProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [pendingStatus, setPendingStatus] = useState<string>("");
  const [status, setStatus] = useState("");
  const { addToast } = CustomToast();
  const { fetchApi } = useFetch(addToast);

  useEffect(() => {
    if (statusDD.length > 0 && employee.status) {
      const match = statusDD.find(s => s.employeeStatus === employee.status);
      if (match) {
        setStatus(match.id.toString());
      }
    }
  }, [statusDD, employee.status]);

  const handleStatusChange = (newStatus: string) => {
    setPendingStatus(newStatus);
    onOpen();
  };

  const handleConfirmStatusChange = async () => {
    if (pendingStatus) {
      try {
        const payload = {
          employeeId: employee.id,
          employeeStatusId: Number(pendingStatus),
        };

        const response = await fetchApi(`Hrlense_Employee/toggleEmpStatus/${employee.id}`, "PUT", payload, "", "");

        if (response?.success) {
          setStatus(pendingStatus);

          const updatedStatusName = statusDD.find((s) => s.id.toString() === pendingStatus)?.employeeStatus;

          if (updatedStatusName) {
            employee.status = updatedStatusName;
          }

          addToast({ message: "Status updated successfully.", status: "success" });
        }
      } catch (error) {
        console.error("Error updating employee status:", error);
        addToast({ message: "An error occurred while updating status.", status: "error" });
      }
    }
    onClose();
  };


  const copyToClipboard = (text: string, type: string) => {
    navigator.clipboard.writeText(text);
    addToast({ message: `${type} copied!`, status: 'success' });
  }

  return (
    <MyDiv>
      <Box className="card" cursor={"pointer"} >
        <Box display="flex" justifyContent="space-between" alignItems="flex-start">
          <Box display="flex">
             <Avatar className="Avatar" name={employee.name} src={employee.avatarUrl || DummyPerson}  />
            <Box className="employee-info" ml={2}>
              <Box display="flex" alignItems="center" gap={2}>
                <Tooltip className="font-poppins text_medium text_xl" label={employee.name} >
                  <Text className="font-poppins text_medium text_xl" maxWidth="12vw" isTruncated>{employee.name}</Text>
                </Tooltip>
                
                <Badge variant="subtle" className="Badge font_dark font-poppins text_medium text_xsm" px={2} py={1} >
                  {employee.empCode}
                  <Image src={CopyIcon} alt="Copy" boxSize="11px" cursor="pointer" onClick={(e) => {
                    e.stopPropagation();
                    copyToClipboard(employee.empCode, "Employee Code");
                  }} />
                </Badge>
              </Box>
              <Box display="flex" gap={2} mt={1}>
                <Tooltip className="font-poppins text_medium text_xl" label={employee.designation} >
                <Badge variant="subtle" className="desig font-poppins text_medium text_xsm" isTruncated maxWidth="7vw">{employee.designation}</Badge>
                </Tooltip>
                <Text className="font-poppins text_medium text_xsm" color="rgba(73, 80, 87, 1)">{employee.department}</Text>
              </Box>
            </Box>
          </Box>
          <Select
            isDisabled
            value={status}
            onChange={(e) => handleStatusChange(e.target.value)}
            className="font-poppins text_medium text_xsm"
            width="78px"
            height="24px"
            icon={<ChevronDownIcon ml={2} />}
            borderRadius="4px"
            color={ statusDD.find((s) => s.id.toString() === status)?.employeeStatus === "Active" ? "#38A169": "#E53E3E"}
            bg={ statusDD.find((s) => s.id.toString() === status)?.employeeStatus === "Active"? "#F0FFF4"  : "#FFF5F5"}
            sx={{ textAlign: "left", paddingLeft: "4px" }}
          >
            {statusDD.map((status) => (
              <option key={status.id} value={status.id}>
                {status.employeeStatus}
              </option>
            ))}
          </Select>
        </Box>

        <Box className="branch">
          <Box mt={2} ml={1}>
            <Box className="info-group" display="flex" flexDirection="column" gap={2}>
              {[{
                icon: BranchIcon,
                label: "Branch",
                value: employee.branch
              }, {
                icon: CompanyIcon,
                label: "Payroll Company",
                value: employee.payrollCompany
              }, {
                icon: CompanyIcon,
                label: "Company",
                value: employee.usCompany
              }].map((item, index) => (
                <Box key={index} display="flex" alignItems="center" gap={2}>
                  <Badge
                    minW="25px"
                    height="25px"
                    borderRadius="full"
                    bg="gray.100"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Image src={item.icon} alt={item.label} boxSize="12px" />
                  </Badge>
                  <Box>
                    <Text className="font-poppins text_medium text_xsm" color="gray.500">
                      {item.label}
                    </Text>
                    <Text className="font-poppins text_medium text_xsm">
                      {item.value}
                    </Text>
                  </Box>
                </Box>
              ))}
            </Box>

            <Flex justifyContent="space-between" alignItems="center" mt={4}>
              <Box display="flex" gap={2}>
                <Tooltip label={`${employee.email}`} placement="top" hasArrow>
                  <Badge
                    minW="25px"
                    height="25px"
                    borderRadius="4px"
                    bg="gray.100"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    _hover={{ bg: "gray.200" }}
                    onClick={(e) => {
                      e.stopPropagation();
                      copyToClipboard(employee.email, "Email");
                    }}
                  >
                    <Image src={InboxIcon} alt="Inbox" cursor="pointer" />
                  </Badge>
                </Tooltip>

                <Tooltip label={`${employee.phone}`} placement="top" hasArrow>
                  <Badge
                    minW="25px"
                    height="25px"
                    borderRadius="4px"
                    bg="gray.100"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    _hover={{ bg: "gray.200" }}
                    onClick={(e) => {
                      e.stopPropagation();
                      copyToClipboard(employee.phone, "Phone number");
                    }}
                  >
                    <Image src={CallIcon} alt="Call" cursor="pointer" />
                  </Badge>
                </Tooltip>
              </Box>
              <Text className="btn font-poppins text_medium text_xsm" color="rgba(9, 146, 80, 1)" mr={3}>
                {employee.presence}
              </Text>
            </Flex>
          </Box>
        </Box>
      </Box>

      <AlertCard
        isOpen={isOpen}
        onClose={onClose}
        onConfirm={handleConfirmStatusChange}
      />
    </MyDiv>
  );
};

export default MyDepartmentCard;